import React, { useContext } from 'react';
import classNames from 'classnames';
import { Button, Dropdown } from 'ncoded-component-library';
import EyeIcon from 'icons/Eye.icon';
import MembersContext from 'router/subrouters/DataRoom/providers/Members/Members.context';
import DataRoomDocumentsContext from '../../providers/DataRoomDocuments/DataRoomDocuments.context';
import useCallbackRef from 'hooks/useCallbackRef';
import { DropdownRef } from 'ncoded-component-library/build/components/molecules/Dropdown/Dropdown.component';
import { useTranslation } from 'react-i18next';
import { getUserFullNameOrEmail, sortUsersByNameThenEmail } from 'utils';
import { DataRoomMember } from 'router/subrouters/DataRoom/models/DataRoomMember';

import './ViewAs.styles.scss';

type ViewAsProps = {
  className?: string;
};

const ViewAs: React.FC<ViewAsProps> = (props) => {
  const { className } = props;

  const { buySideMembers } = useContext(MembersContext);
  const { buySidePreviewMember, canChangeView, updateBuySidePreviewMember } =
    useContext(DataRoomDocumentsContext);

  const name = getUserFullNameOrEmail(buySidePreviewMember);

  const [dropdown, dropdownRef] = useCallbackRef<DropdownRef>();

  const { t } = useTranslation();

  const classes = classNames('view-as', className);

  if (!canChangeView) return null;

  return (
    <Dropdown
      closeWithJS
      renderAsPortal
      className={classes}
      contentClassName="view-as__content"
      ref={dropdownRef}
      trigger={
        <Button variant="outline" icon={EyeIcon}>
          {t('viewAs', {
            name: buySidePreviewMember ? name || t('unknownUser') : '',
          })}
        </Button>
      }
    >
      <ul className="view-as__list">
        {(sortUsersByNameThenEmail(buySideMembers) as DataRoomMember[]).map(
          (member) => (
            <li
              key={member._id}
              className={classNames({
                selected: member._id === buySidePreviewMember?._id,
              })}
              onClick={() => {
                updateBuySidePreviewMember(member);
                dropdown.setIsOpen(false);
              }}
            >
              {getUserFullNameOrEmail(member) || t('unknownUser')}
            </li>
          ),
        )}
      </ul>
    </Dropdown>
  );
};

export default ViewAs;
